import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedSection from './components/FeaturedSection';
import LatestUpdates from './components/LatestUpdates';
import SchemaJsonLd from '@/components/base/SchemaJsonLd';

export default function Home() {
  useEffect(() => {
    document.title = '屁屁影院 - 精选影视资源在线观看 | 免费高清电影电视剧动漫';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', '屁屁影院是您最佳的在线影视娱乐平台，提供海量高清电影、电视剧、动漫资源，无需注册即可免费观看。每日更新最新影视内容。');
  }, []);

  const schemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '屁屁影院',
      url: 'https://pipicinema.com/',
      description: '屁屁影院是您最佳的在线影视娱乐平台，提供海量高清电影、电视剧、动漫资源，无需注册即可免费观看。',
      logo: 'https://pipicinema.com/logo.png',
      sameAs: [],
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '屁屁影院',
      url: 'https://pipicinema.com/',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://pipicinema.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '屁屁影院 - 精选影视资源在线观看',
      description: '屁屁影院是您最佳的在线影视娱乐平台，提供海量高清电影、电视剧、动漫资源，无需注册即可免费观看。',
      url: 'https://pipicinema.com/',
      isPartOf: {
        '@type': 'WebSite',
        name: '屁屁影院',
        url: 'https://pipicinema.com/',
      },
    },
  ];

  return (
    <>
      <SchemaJsonLd schemas={schemas} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedSection />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}